import goalIcon from './../assets/img/icons/goal.svg'
import ownGoalIcon from './../assets/img/icons/own-goal.svg'
import substitutionIcon from './../assets/img/icons/substitution.svg'
import substitutionInIcon from './../assets/img/icons/substitution-in.svg'
import substitutionOutIcon from './../assets/img/icons/substitution-out.svg'
import yellowCardIcon from './../assets/img/icons/yellow-card.svg'
import redCardIcon from './../assets/img/icons/red-card.svg'
import yellowRedCardIcon from './../assets/img/icons/yellow-red-card.svg'
import videoAssistIcon from './../assets/img/icons/video-assist.svg'

export default {
	methods: {
		getIconForAction (action) {
			switch (action) {
			case 'goal': return goalIcon
			case 'own-goal': return ownGoalIcon
			case 'substitution': return substitutionIcon
			case 'substitution-in': return substitutionInIcon
			case 'substitution-out': return substitutionOutIcon
			case 'yellow-card': return yellowCardIcon
			case 'red-card': return redCardIcon
			case 'yellow-red-card': return yellowRedCardIcon
			case 'video-assist': return videoAssistIcon
			default: return null
			}
		}
	}
}
